export const PLAYGROUND_KEY_COOKIE_NAME = "llmgateway_playground_key";
export const PLAYGROUND_KEY_COOKIE_MAX_AGE = 60 * 60 * 24 * 90;
